export class ProductOptions extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['optionRow', 'variants']
  }

  static get requiredExternalElements () {
    return ['variantId', 'submit', 'submitText']
  }

  constructor () {
    super()

    this.variants = JSON.parse(this.els.variants.element.textContent)
  }

  setupListeners () {
    super.setupListeners()

    this.update = this.update.bind(this)

    this.listeners.add(this, 'change', this.update)
  }

  /**
   * @returns {void}
   */
  update () {
    const variant = this.selectedVariant

    this.updateLabels()
    this.updateForm(variant)
    this.updateUrl(variant)

    window.BAO.dispatchEvent(window.BAO.EVENTS.PRODUCT.OPTION_SELECTED, {
      variant,
    })
  }

  /**
   * @returns {void}
   */
  updateLabels () {
    this.els.optionRow.elements.forEach((row) => {
      const label = row.querySelector('[data-product-options-el="label"]')

      if (label) {
        label.textContent = this.valueFor(row) || ''
      }
    })
  }

  /**
   * @param {Object|null} variant
   *
   * @returns {void}
   */
  updateForm (variant) {
    const els = this.externalEls
    const { addToCart, soldOut, unavailable } = window.theme.strings

    const disabled = !variant || !variant.available
    const text = variant ? (variant.available ? addToCart : soldOut) : unavailable

    els.variantId.elements.forEach((el) => {
      el.value = variant ? variant.id : ''
    })

    els.submit.elements.forEach((el) => {
      el.disabled = disabled
    })

    els.submitText.elements.forEach((el) => {
      el.textContent = text
    })
  }

  /**
   * @param {Object|null} variant
   *
   * @returns {void}
   */
  updateUrl (variant) {
    if (!variant || !this.shouldUpdateUrl) return

    const url = new URL(window.location.href)

    url.searchParams.set('variant', variant.id)
    window.history.replaceState({}, '', url)
  }

  /**
   * @param {HTMLElement} row
   *
   * @returns {string|null}
   */
  valueFor (row) {
    const select = row.querySelector('select')

    if (select) return select.value

    const checked = row.querySelector('input:checked')

    return checked ? checked.value : null
  }

  /**
   * @returns {(string|null)[]}
   */
  get selectedValues () {
    return this.els.optionRow.elements.map((row) => this.valueFor(row))
  }

  /**
   * @returns {Object|null}
   */
  get selectedVariant () {
    const values = this.selectedValues

    return (
      this.variants.find((variant) =>
        variant.options.every((option, index) => option === values[index]),
      ) || null
    )
  }

  /**
   * @returns {boolean}
   */
  get shouldUpdateUrl () {
    const info = this.closest('[data-update-url]')

    return info ? info.getAttribute('data-update-url') === 'true' : false
  }
}

if (!customElements.get('product-options')) {
  customElements.define('product-options', ProductOptions)
}
